module.exports = __webpack_public_path__ + "media/audio5.46dbe124.wav";